import Config from '@/config';
import LocationSelect from '@/components/inputs/location-select';

export default ({
  dataKey = 'address'
} = {}) => ({
  data() {
    return {
      politicalDivisions: Config.get('ADDRESS_POLITICAL_DIVISIONS'),
    };
  },

  components: { LocationSelect },

  created() {
    this.$addressInput = {
      onInput: (value, idx) => {
        if(this.data[dataKey]._locationIds[idx] !== value)
          this.data[dataKey]._locationIds = [...this.data[dataKey]._locationIds.slice(0, idx), value];
      },

      isDisabled: (idx) => {
        return idx > this.data[dataKey]._locationIds.length;
      },

      getValue: (idx) => {
        return this.data[dataKey]._locationIds[idx];
      },

      getParentId: (idx) => {
        return this.data[dataKey]._locationIds?.[idx - 1];
      },
    };
  },
});